var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "next-step-filled-items" }, [
    _vm.isLocalizedAttribute()
      ? _c("span", { staticClass: "attribute-label" }, [
          _vm._v(_vm._s(_vm.$t("chatbotv2.attr." + _vm.attribute))),
        ])
      : _vm.attribute.startsWith("contact_property_")
      ? _c("span", [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.visitorContactAttributes[
                  _vm.attribute.replace("contact_property_", "")
                ]
              ) +
              "\n    "
          ),
        ])
      : _c("span", { staticClass: "attribute-label" }, [
          _vm._v(_vm._s(_vm.attribute)),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }